import { ReactNode, useId } from 'react';
import Tooltip from '@/components/Tooltip';

type TooltipProps =
  | {
      tooltip: ReactNode;
      labelTerm: ReactNode;
    }
  | {
      tooltip?: never;
      labelTerm?: never;
    };

type Props = {
  children: ReactNode;
  label: ReactNode;
} & TooltipProps;

export const LabelledValue = ({
  label,
  labelTerm,
  children,
  tooltip,
}: Props) => {
  const id = useId();
  return (
    <div className="grid grid-cols-[auto_auto] justify-between text-solid">
      <div className="text-xs" id={id}>
        {label}{' '}
        {tooltip && (
          <Tooltip
            title={
              <p className="m-0 max-w-[200px] text-tiny text-p-grey-30">
                {tooltip}
              </p>
            }
            light
          >
            <span className="inline-block border-0 border-b border-dotted whitespace-nowrap border-brand-01 cursor-help bg-brand-01/10">
              {labelTerm}
            </span>
          </Tooltip>
        )}
      </div>
      {children && (
        <div className="text-xs" aria-labelledby={id}>
          {children}
        </div>
      )}
    </div>
  );
};
